import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { CREATE_ATTRIBUTE, CREATE_ATTRIBUTE_SUCCESS, CREATE_ATTRIBUTE_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* createAttribute({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/attributes`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Attribute created successfully!`);
      // cogoToast.success(`${response?.data?.message}`)
      yield put({
        type: CREATE_ATTRIBUTE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({
      //     type: CREATE_ATTRIBUTE_ERROR,
      //     payload: response?.data?.message,
      // })
    }
  } catch (error) {
    yield put({ type: CREATE_ATTRIBUTE_ERROR, payload: error });
  }
}

export function* watchCreateAttributeSaga() {
  yield takeEvery(CREATE_ATTRIBUTE, createAttribute);
}

function* createAttributeSaga() {
  yield all([fork(watchCreateAttributeSaga)]);
}

export default createAttributeSaga;
